export type MyPageNavItem = {
  href: string;
  label: string;
  description?: string;
};

export type MyPageNavSection = {
  id: string;
  title: string;
  items: MyPageNavItem[];
};

/** 내 활동 허브에 묶이는 하위 페이지 */
export const MY_PAGE_ACTIVITY_ITEMS: MyPageNavItem[] = [
  {
    href: "/profile/reports",
    label: "음악 리포트",
    description: "프로 피드백 결과",
  },
  {
    href: "/profile/growth",
    label: "성장 리포트",
    description: "피드백·AI·레슨 타임라인",
  },
  {
    href: "/profile/expert-analysis",
    label: "피드백 신청내역",
    description: "진행·완료·결제 상태",
  },
  {
    href: "/profile/lessons",
    label: "레슨 예약",
    description: "결제 확정된 레슨 일정",
  },
];

/** 내 활동 하위 경로인지 (사이드바 활성 표시용) */
export function isMyPageActivityPath(pathname: string): boolean {
  if (pathname === "/profile/activity") return true;
  return MY_PAGE_ACTIVITY_ITEMS.some(
    item =>
      pathname === item.href || pathname.startsWith(`${item.href}/`)
  ) || pathname.startsWith("/profile/report/");
}

/** 마이페이지 공통 메뉴 (쿠팡/크몽형 허브) */
export const MY_PAGE_NAV: MyPageNavSection[] = [
  {
    id: "home",
    title: "마이페이지",
    items: [
      {
        href: "/profile",
        label: "홈",
        description: "요약·설정 입구",
      },
      {
        href: "/profile/activity",
        label: "내 활동",
        description: "리포트·피드백·레슨",
      },
    ],
  },
  {
    id: "benefits",
    title: "내 혜택",
    items: [
      {
        href: "/profile/points",
        label: "포인트",
        description: "적립·사용 내역",
      },
    ],
  },
  {
    id: "info",
    title: "내 정보",
    items: [
      {
        href: "/profile/edit",
        label: "프로필 관리",
        description: "닉네임·소개·아바타",
      },
      {
        href: "/profile/settings",
        label: "계정·보안",
        description: "인증·비밀번호 관리",
      },
    ],
  },
];

export const MY_PAGE_SUPPORT_LINKS: MyPageNavItem[] = [
  // 고객센터(/help)는 당분간 비활성화
  { href: "/profile/inquiries", label: "문의 내역" },
  { href: "/profile/inquiries?tab=compose", label: "1:1 문의" },
];
